import { map } from 'lodash';
import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchVideoCourseList({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/video-courses`, { params })
    .then(res => (res.data))
    .then(videoCourses => (
      dispatch('fetchUnitList', map(videoCourses, 'id'))
        .then(() => (videoCourses))
    ))
    .then(videoCourses => (
      dispatch('setVideoCoursesInStore', videoCourses)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching video courses:', err);
      return Promise.reject(err);
    });
}

export function fetchUnitList({ dispatch }, videoCourseIds) {
  if (videoCourseIds.length === 0) {
    return Promise.resolve([]);
  }

  return http.get(`${MINERVA_API_URL}/core_concept_video_courses`, { params: { video_course_ids: videoCourseIds } })
    .then(res => (res.data))
    .then(coreConceptVideoCourses => (
      dispatch('setCoreConceptVideoCoursesInStore', coreConceptVideoCourses)
    ))
    .then((coreConceptVideoCourses) => {
      const coreConceptIds = map(coreConceptVideoCourses, 'core_concept_id');
      if (coreConceptIds.length === 0) {
        return Promise.resolve([]);
      }
      return http.get(`${MINERVA_API_URL}/units`, { params: { core_concept_ids: coreConceptIds } })
        .then(res => (res.data))
        .then(units => (
          dispatch('setUnitsWithCoreConceptsInStore', units)
        ));
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching units:', err);
      return Promise.reject(err);
    });
}

export function fetchVideoCourse({ dispatch }, courseId) {
  return http.get(`${MINERVA_API_URL}/video-courses/${courseId}`)
    .then(res => (res.data))
    .then(videoCourse => (
      dispatch('setVideoCoursesInStore', [videoCourse])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching video course by ID:', err);
      return Promise.reject(err);
    });
}

export function createNewVideoCourse({ dispatch }, params) {
  return http.post(`${MINERVA_API_URL}/video-courses`, params)
    .then(res => (res.data))
    .then(videoCourse => (
      dispatch('fetchVideoCourse', videoCourse.id)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while creating a new video course:', err);
      return Promise.reject(err);
    });
}

export function updateVideoCourse({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/video-courses/${params.id}`, params)
    .then(res => (res.data))
    .then(() => (
      dispatch('fetchVideoCourse', params.id)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating a video course:', err);
      return Promise.reject(err);
    });
}

export function updateVideoCourseLecturesShareLevel({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/video-courses/${params.id}/share-levels`, params)
    .then(() => (
      dispatch('clearVideoLecturesInStore')
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating video course lectures share level:', err);
      return Promise.reject(err);
    });
}

export function removeVideoCourse({ dispatch }, courseId) {
  return http.delete(`${MINERVA_API_URL}/video-courses/${courseId}`)
    .then(res => (res.data))
    .then(() => (
      dispatch('removeVideoCourseInStore', courseId)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing a video course:', err);
      return Promise.reject(err);
    });
}

export function setCoreConceptVideoCoursesInStore({ commit }, coreConceptVideoCourses) {
  commit(types.SET_CORE_CONCEPT_VIDEO_COURSES, coreConceptVideoCourses);

  return Promise.resolve(coreConceptVideoCourses);
}

export function setUnitsWithCoreConceptsInStore({ commit }, units) {
  commit(types.SET_UNITS_WITH_CORE_CONCEPTS, units);

  return Promise.resolve(units);
}

export function setVideoCoursesInStore({ commit }, videoCourses) {
  commit(types.SET_VIDEO_COURSES, videoCourses);

  return Promise.resolve(videoCourses);
}

export function removeVideoCourseInStore({ commit }, courseId) {
  commit(types.REMOVE_VIDEO_COURSE, courseId);

  return Promise.resolve(courseId);
}

export function createCoreConceptVideoCourse({ commit }, data) {
  return http.post(`${MINERVA_API_URL}/core_concept_video_courses`, data)
    .then(res => commit(types.SET_CORE_CONCEPT_VIDEO_COURSE, res.data))
    .catch(err => Promise.reject(err));
}

export function fetchCoreConceptVideoCourses({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/core_concept_video_courses`, { params })
    .then(res => commit(types.FETCH_CORE_CONCEPT_VIDEO_COURSES, res.data))
    .catch(err => Promise.reject(err));
}

export function updateCoreConceptVideoCourse({ commit }, data) {
  return http.put(`${MINERVA_API_URL}/core_concept_video_courses/${data.id}`, data)
    .then(res => commit(types.UPDATE_CORE_CONCEPT_VIDEO_COURSE, res.data))
    .catch(err => Promise.reject(err));
}



// WEBPACK FOOTER //
// ./src/app/video-courses/store/actions.js